export const APP_ROUTES = {
  SignIn: '/sign-in',
  SignUp: '/sign-up',
  Verify: '/verify',
  Tokens: '/tokens',
  SignOut: '/sign-out',
  Account: '/account',
  Check: '/check-auth',
}
